// Texte de la page « Aide » : questions courtes, réponses sobres. Vocabulaire de docs/REGLE-EDITORIALE.md : les euros sont
// des pertes potentielles estimées, les mesures NIS2 un indicateur de progression, jamais une certification.
import { typo } from './typo';

export const ADRESSE_CONTACT = 'contact@ekera.ai';

export interface QuestionAide {
  id: string;
  question: string;
  /** Un paragraphe par entrée. */
  reponse: string[];
}

const brut: QuestionAide[] = [
  {
    id: 'par-ou-commencer',
    question: 'Par où commencer ?',
    reponse: [
      'Déposez quelques exports de vos outils (inventaire GLPI, annuaire, configuration du pare-feu, console cloud, Microsoft 365, achats, tickets, fichier des écritures comptables) et les documents que vous avez déjà (schémas, politiques, contrats). Lancez ensuite la lecture, répondez aux questions de l’entretien, puis parcourez la carte et les scénarios.',
      'Le parcours « Premiers pas » du tableau de bord suit ces étapes et montre où vous en êtes.',
    ],
  },
  {
    id: 'pieces',
    question: 'Que fait Ekera de mes pièces ?',
    reponse: [
      'Ekera les lit pour dessiner la carte de votre système d’information : applications, machines, comptes, fournisseurs, sauvegardes et les liens entre eux. Pour chaque fait, la carte cite la pièce et le passage d’où il vient, et la citation est vérifiée mot pour mot.',
      'Le type d’un fichier est reconnu à son contenu, pas à son nom. Les pièces sont rangées chiffrées, propres à votre entreprise ; aucune n’est ouverte ni exécutée à la réception, et la lecture se fait dans un processus isolé.',
      'Ekera ne supprime rien dans vos outils. Toute écriture passe d’abord par une simulation, puis par votre confirmation ; une erreur se corrige par une opération inverse, tracée au journal.',
    ],
  },
  {
    id: 'souverainete',
    question: 'Où vont mes données ? (souveraineté)',
    reponse: [
      'Ekera n’appelle que des modèles ouverts, hébergés en France ou chez l’entreprise. Aucune donnée ne part vers une API américaine. Selon la configuration, la lecture peut aussi se faire par règles, sans modèle de langage : l’écran « Dépôt des documents » dit quel mode est en service.',
      'Vos pièces et vos réponses ne servent ni à régler les consignes d’Ekera ni à entraîner un modèle.',
    ],
  },
  {
    id: 'chiffres',
    question: 'Comment lire les chiffres ?',
    reponse: [
      'Les montants viennent d’un moteur de calcul déterministe, à partir de votre carte, de vos comptes et d’hypothèses, jamais d’un modèle de langage. Ce sont des pertes potentielles estimées, conditionnelles aux hypothèses retenues (calibration provisoire, non validée par un actuaire). Les fréquences sont estimées par le modèle, à calibrer selon le contexte.',
      'L’indicateur NIS2 est un indicateur de progression sur les mesures évaluées, pas une certification de conformité. Les scénarios d’investissement sont proposés, à valider par l’entreprise : la décision vous appartient.',
    ],
  },
  {
    id: 'a-confirmer',
    question: 'Que sont les « points à confirmer » ?',
    reponse: [
      'Ce sont les endroits où les pièces ne tranchent pas, ou se contredisent. Ekera ne conclut pas à votre place : il vous pose la question dans l’entretien, ou la laisse ouverte si vous répondez « Je ne sais pas ». Ce sont des points à confirmer avant de prendre une décision, pas des erreurs.',
    ],
  },
  {
    id: 'rapport',
    question: 'Quand générer le rapport de diagnostic ?',
    reponse: [
      'Une fois les pièces lues et l’entretien fait : le rapport reprend la carte telle qu’elle est à cet instant. Vous pouvez en générer un nouveau quand la carte change ; les anciens restent téléchargeables.',
    ],
  },
  {
    id: 'lecture-seule',
    question: 'Pourquoi ne puis-je pas déposer de pièces ?',
    reponse: [
      'Le dépôt, la lecture et l’entretien demandent le rôle « écriture ». Le bas du menu indique votre rôle. Demandez à une personne qui l’a de s’en charger, ou écrivez-nous.',
    ],
  },
];

export const QUESTIONS_AIDE: readonly QuestionAide[] = brut.map((q) => ({
  ...q,
  question: typo(q.question),
  reponse: q.reponse.map(typo),
}));

export const TEXTE_CONTACT = typo(
  'Une question, un blocage, un doute sur un écran : écrivez-nous. Dites sur quel écran vous étiez et ce que vous attendiez ; ne joignez ni mot de passe ni pièce confidentielle.',
);
